"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullName = getFullName;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

function getFullName(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email;
  return _I18n.default.formatName({
    firstName: firstName,
    lastName: lastName
  }) || email;
}

var User =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(User, _Record);

  function User() {
    (0, _classCallCheck2.default)(this, User);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(User).apply(this, arguments));
  }

  return User;
}((0, _immutable.Record)({
  id: undefined,
  firstName: '',
  lastName: '',
  email: ''
}, 'User'));

var _default = User;
exports.default = _default;